function querySelectorNonNull<E extends Element = Element>(parentNode: ParentNode, selector: string): E {
    const element: E | null = parentNode.querySelector(selector)
    if (!element) {
        throw new Error(`Element with selector "${selector}" not found`)
    }
    return element
}

export { querySelectorNonNull }
